import React, { useMemo } from 'react';

import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import { useLocalization } from 'gatsby-theme-i18n';
import LinkItem from "../../../components/LinkItem/LinkItem";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';
import { parseHTML } from '../../../functions/common';

const BannerSection = () => {

  const data = useStaticQuery(graphql`
  query BannerSection {
    background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_banner.png"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    latestExpansion : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_latestExpansion.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    latestExpansion_global : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_latestExpansion_global.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    latestExpansion_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_latestExpansion_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    latestExpansion_global_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_latestExpansion_global_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    officialGoods : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_officialGoods.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    officialGoods_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/button_officialGoods_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    
  }
`);

const { t, currentLocaleObj } = useLocalization();

let latestExpansionBanner = useMemo(() => {
  if(currentLocaleObj.code === "ja")
    return withArtDirection(getImage(data.latestExpansion), [
        {
          media: `(min-width: ${breakpoint.mdMin})`,
          image: getImage(data.latestExpansion),
        },
        {
          media: `(max-width: ${breakpoint.smMax})`,
          image: getImage(data.latestExpansion_tablet),
        }
      ])
  else
    return withArtDirection(getImage(data.latestExpansion_global), [
      {
        media: `(min-width: ${breakpoint.mdMin})`,
        image: getImage(data.latestExpansion_global),
      },
      {
        media: `(max-width: ${breakpoint.smMax})`,
        image: getImage(data.latestExpansion_global_tablet),
      }
    ])
},[currentLocaleObj,data])

  return(
    <BannerSectionWrapper>
      <AnimatedSection>
        <BannerWrapper>
          <Banner>
            <BannerHeadline>
              <span>{t('nav.latest_ex.label')}</span>
              <span>{parseHTML(t('nav.latest_ex.title'))}</span>
            </BannerHeadline>
            <BannerVisual href={t('nav.latest_ex.url')}>
              <GatsbyImage image={latestExpansionBanner} alt={t('nav.latest_ex.title')}/>
            </BannerVisual>
            <BannerLabel>{t('nav.latest_ex.button.label')}</BannerLabel>
          </Banner>
          <Banner>
            <BannerHeadline>
              <span>{t('nav.official_goods.label')}</span>
              <span>{t('nav.official_goods.title')}</span>
            </BannerHeadline>
            <BannerVisual fade to={`/${currentLocaleObj.prefix}/goods/`}>
              <GatsbyImage
                image={ withArtDirection(getImage(data.officialGoods), [
                  {
                    media: `(min-width: ${breakpoint.mdMin})`,
                    image: getImage(data.officialGoods),
                  },
                  {
                    media: `(max-width: ${breakpoint.smMax})`,
                    image: getImage(data.officialGoods_tablet),
                  }
                ])} alt={t('nav.official_goods.title')}/>
            </BannerVisual>
            <BannerLabel>{t('nav.official_goods.button.label')}</BannerLabel>
          </Banner>
        </BannerWrapper>
      </AnimatedSection>
      <Background>
        <GatsbyImage image={getImage(data.background)} alt="background" />
      </Background>
    </BannerSectionWrapper>
  );
}

export default BannerSection;

const BannerSectionWrapper = styled.div`
  background:#F7F7FA;
  padding:96px 0 96px;
  position:relative;
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 40px 60px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:32px 0px 0px;
  }
`

const BannerWrapper = styled.div`
  display:flex;
  width:1440px;
  margin:0 auto;
  position:relative;
  z-index:2;
  max-width:100%;
  padding:0 24px;

  @media only screen and (max-width: ${breakpoint.xsMax}){
    flex-wrap:wrap;
  }
`

const Banner = styled.div`
  width:50%;
  padding:0 24px;
  position:relative;
  text-decoration:none;

  display:flex;
  flex-direction: column;
  justify-content: flex-end;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0 16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0 0 32px 0;
    width:100%;
  }
  
`

const BannerVisual = styled(LinkItem)`
display:block;
box-sizing: border-box;

box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
border-radius: 12px;
overflow:hidden;
z-index:1;

transition:all .3s;

&:hover{
  transform:scale(1.15);
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  &:hover{
    transform:none;
  }
}
`

const BannerHeadline = styled.div`
  margin-bottom:16px;
  > span{
    display:block;

    &:nth-of-type(1){
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.05em;
      color: #D00F31;
    }

    &:nth-of-type(2){
      font-weight: 900;
      font-size: 36px;
      line-height: 48px;
      letter-spacing: 0.01em;
      color: #2C2C2E;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    > span{
      &:nth-of-type(1){
        font-size: 12px;
        line-height: 16px;
      }
      &:nth-of-type(2){
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    > span{
      &:nth-of-type(1){
        font-size: 10px;
        line-height: 14px;
      }
      &:nth-of-type(2){
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
`

const BannerLabel = styled(LinkItem)`
  display:block;
  position:absolute;
  bottom:-8px;
  right:8px;
  background: #F50057;
  box-shadow: 0px 6px 8px -4px rgba(255, 54, 78, 0.5);
  border-radius: 6px;
  padding: 8px 24px;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFF;
  letter-spacing: 0.1em;
  transition:all .3s;
  opacity:0;
  z-index:10;

  a:hover + &{
    background:#FF186A;
    bottom: calc(-5% - 8px);
    right: calc(-5% + 8px);
    opacity:1;
  }

  a:active + &{
    background:#D7004C;
    bottom: calc(-5% - 8px);
    right: calc(-5% + 8px);
    opacity:1;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    transition:opacity .3s;
    bottom: 24px;
      right:-8px;
    a:hover + &{
      bottom: 24px;
      right:-8px;
      
    }
  }
`

const Background = styled.div`
  position:absolute;
  width:100%;
  bottom:0;
  left:0;
`
